/* eslint-disable */
(function ($) {
  $(document).on('click', '.loadMoreJobOffersButton', function (e) {
    e.preventDefault();
    // var url = $(this).attr('href');
    const url = $(this).attr('data-url');
    $.ajax({
      method: "GET",
      url: url
    }).done(function (data) {
      $('#jobOffersLoadMoreContainer').replaceWith(data);
    });
  });
})($);
$(document).ready(() => {
  if (window.location.hash.length > 0) {
    window.scrollTo(0, $(window.location.hash).offset().top);
  }
});
$('.tx-powermail form').on('submit', function (e) {
  e.preventDefault();
  const form = $(this);
  form.parsley().validate();
  if (form.parsley().isValid()) {
    const button = $(this).find('.o-button--primary');
    button.addClass('disabled');
    button.prop('disabled', true);
  }
});
$('.powermail_form').on('submit', function (e) {
  const form = $(this);
  form.parsley().validate();
  if (form.parsley().isValid()) {
    const button = $(this).find('.o-button--primary');
    button.addClass('disabled');
    button.prop('disabled', true);
  }
});
document.addEventListener('DOMContentLoaded', () => {
  // Alle Links im mobilen Menü auswählen
  const mobileMenuLinks = document.querySelectorAll('.c-navigation__third-level-link');
  const offset = 80; // Höhe des Headers, für beide Fälle gleich

  mobileMenuLinks.forEach(link => {
    link.addEventListener('click', event => {
      const href = link.getAttribute('href');

      // Prüfen, ob der Link ein Anker auf der aktuellen Seite ist
      const url = new URL(href, window.location.href);
      const isAnchorLink = url.hash && url.origin + url.pathname === window.location.origin + window.location.pathname;
      if (isAnchorLink) {
        event.preventDefault(); // Verhindert das normale Verhalten des Links

        // Menü schließen und anschließend scrollen
        closeMobileMenu(() => {
          scrollToAnchor(url.hash, offset); // Scrollen mit Offset
        });
      }
    });
  });
  function closeMobileMenu(callback) {
    // Menü manuell schließen
    const header = document.querySelector('.o-page__header');
    const stickyHeader = document.querySelector('.o-page__header--clone');
    if (header && header.__x) {
      header.__x.$data.menuVisible = false;
      header.__x.$data.secondLevelVisible = false;
    }
    if (stickyHeader && stickyHeader.__x) {
      stickyHeader.__x.$data.menuVisible = false;
      stickyHeader.__x.$data.secondLevelVisible = false;
    }

    // Callback-Funktion aufrufen, um das Scrollen durchzuführen
    if (typeof callback === 'function') {
      setTimeout(callback, 300); // 300ms Verzögerung
    }
  }

  // Allgemeiner Ankerlink-Handler
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const targetElement = document.querySelector(href);
      if (targetElement) {
        e.preventDefault();
        scrollToAnchor(href, offset);
      }
    });
  });

  // Funktion zum Scrollen mit Offset
  function scrollToAnchor(hash, offset) {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
      const elementRect = targetElement.getBoundingClientRect().top;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
});